import React from "react";
import ReactDOM from "react-dom/client";
import "./css/index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/auth/auth.js";
import reportWebVitals from "./reportWebVitals";

/* ===============================
   SUPPRESS ResizeObserver ERROR
   (CRA + Chrome + MUI Safe)
   =============================== */

// 1️⃣ Suppress console.error (CRA overlay source)
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    args[0] &&
    typeof args[0] === "string" &&
    args[0].includes("ResizeObserver loop completed")
  ) {
    return;
  }
  originalConsoleError(...args);
};

// 2️⃣ Suppress window error event
window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop completed")) {
    e.stopImmediatePropagation();
  }
});

// 3️⃣ Patch ResizeObserver (prevents loop crash)
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      try {
        callback(entries, observer);
      } catch (err) {
        if (!err.message?.includes("ResizeObserver loop")) {
          throw err;
        }
      }
    });
  }
};

/* ===============================
   APP RENDER
   =============================== */

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();
